<section>
    <app-watchlist-agent-info [agentInfo]="agentInfo" pageType="myWatchlist"></app-watchlist-agent-info>

    <div class="mt-4 md:mt-10 relative">
        <nz-tabset [(nzSelectedIndex)]="tabIndex">
            <ng-template #walletsTabTitle>
                <div class="flex-start-center gap-x-2.5">
                    <span>Wallets</span>
                    <div class="text-sub-text flex-start-center whitespace-nowrap text-xs font-normal">
                        <span>Total </span>
                        <span class="text-black ml-1"> {{watchList?.length || 0}} </span>
                        <span>/ {{memeDashboardStatusService.WatchLimitCount}}</span>
                        <span nz-icon nzType="info-circle" class="ml-1" nz-tooltip="A maximum of 50 addresses can be added"></span>
                    </div>
                </div>
            </ng-template>

            <nz-tab [nzTitle]="walletsTabTitle">
                <div>
                    <div *ngIf="tabIndex === 0" class="md:absolute flex-between-center max-md:mb-4 md:flex-end-center gap-x-2 right-0 top-2 z-10">
                        <div class="flex-start-center max-md:text-sm">
                            <button nz-button class="ml-2 md:ml-4 !h-[28px] relative" (click)="memeDashboardService.showAddWatchlistDialog()">
                                <span nz-icon nzType="plus"></span>
                                Add

                                <div *ngIf="!isWatchListAdded" class="bonus-watchlist-points z-10">
                                    <img src="/assets/imgs/icon/sun-v2.png" class="w-[14px]" alt="" />
                                    <span>+100</span>
                                </div>
                            </button>
                        </div>

                        <nz-input-group [nzPrefix]="prefixTemplateUser" class="max-md:flex-1 md:!w-[220px] search-address-input">
                            <input
                                type="text"
                                nz-input
                                placeholder="Search My Watchlist"
                                class="!leading-1"
                                [ngModel]="searchedAddress"
                                [disabled]="!watchList?.length"
                                (ngModelChange)="onSearch($event)"
                            />
                        </nz-input-group>
                        <ng-template #prefixTemplateUser><span nz-icon nzType="antd:v2-search" class="!text-lg"></span></ng-template>

                        <app-chain-select [(selectedChain)]="chain" (selectedChainChange)="chainChange()"></app-chain-select>
                    </div>

                    <nz-table
                        #trendingTable
                        [nzData]="filteredWatchList"
                        nzTableLayout="fixed"
                        [nzScroll]="{ x: '800px' }"
                        [nzFrontPagination]="false"
                        [nzLoading]="fetchingWatchlistWallets"
                        [nzNoResult]="noResult"
                    >
                        <thead>
                            <tr>
                                <th *ngFor="let column of columns" [nzWidth]="column.width" class="whitespace-nowrap">{{column.name}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of trendingTable.data; let i = index">
                                <td>
                                    <img
                                        *ngIf="unsubscribedAddresses.includes(data.address)"
                                        src="/assets/imgs/icon/subscribe.png"
                                        class="w-5 h-auto cursor-pointer"
                                        (click)="addAddressToWatchlist(data.address);$event.stopPropagation()"
                                        alt=""
                                    />
                                    <img
                                        *ngIf="!unsubscribedAddresses.includes(data.address)"
                                        src="/assets/imgs/icon/subscribed.png"
                                        class="w-5 h-auto cursor-pointer"
                                        (click)="removeAddressFromWatchlist(data.address);$event.stopPropagation()"
                                        alt=""
                                    />
                                </td>

                                <td>{{i + 1}}</td>

                                <td>
                                    <div class="w-full flex-start-center gap-x-2" (click)="$event.stopPropagation()">
                                        <app-hexagon-img [imgUrl]="commonService.getAddressIcon(data.address)" class="w-8"></app-hexagon-img>

                                        <div class="text-sm flex-1 min-w-0 space-y-1">
                                            <div class="flex-start-center text-sm gap-x-1">
                                                <span>{{data.address | address}}</span>
                                                <span
                                                    nz-icon
                                                    nzType="antd:v2-copy"
                                                    class="hover:text-black text-sub-text text-sm !cursor-pointer"
                                                    appCopy
                                                    [copyText]="data.address"
                                                    (click)="$event.stopPropagation()"
                                                ></span>

                                                <img *ngIf="data.address.startsWith('0x')" src="/assets/imgs/chains/eth-blue.png" class="w-3 h-auto" alt="" />

                                                <img *ngIf="!data.address.startsWith('0x')" src="/assets/imgs/chains/solana.png" class="w-3 h-auto" alt="" />

                                                <img
                                                    *ngIf="data.is_smart_money"
                                                    nz-tooltip="Smart Money"
                                                    src="/assets/imgs/icon/money.png"
                                                    class="w-5 h-auto"
                                                    alt=""
                                                />
                                                <img *ngIf="data.is_whale" nz-tooltip="Whale" src="/assets/imgs/icon/whale.png" class="w-5 h-auto" alt="" />
                                            </div>
                                            <div class="text-xs text-sub-text flex-start-center gap-x-1 w-full h-[22px]">
                                                <!-- 非编辑状态 -->
                                                <ng-container *ngIf="!isEditing(data.address)">
                                                    <div *ngIf="data.label" class="text-[#FF8811] min-w-0 truncate max-w-fit">{{data.label}}</div>
                                                    <span
                                                        nz-icon
                                                        nzType="antd:v2-edit"
                                                        class="hover:text-black text-sm !cursor-pointer"
                                                        (click)="startEdit(data)"
                                                    ></span>
                                                </ng-container>

                                                <!-- 编辑状态 -->
                                                <ng-container *ngIf="isEditing(data.address)">
                                                    <nz-input-group [nzSuffix]="inputButtons" class="flex-1 !h-[22px] !px-1 !py-0 !rounded">
                                                        <input
                                                            nz-input
                                                            [ngModel]="getEditingNote(data.address)"
                                                            (ngModelChange)="setEditingNote(data.address, $event)"
                                                            class="!text-sm !rounded-none"
                                                        />
                                                    </nz-input-group>
                                                    <ng-template #inputButtons>
                                                        <div class="flex-center-center gap-x-1 text-2xs">
                                                            <div
                                                                class="w-3 h-3 bg-secondaryCard rounded-sm flex-center-center hover:bg-black hover:text-white"
                                                                (click)="saveNotes(data.address)"
                                                            >
                                                                <span
                                                                    nz-icon
                                                                    [nzType]="savingNotesAddresses.includes(data.address) ? 'loading' : 'check'"
                                                                    class="!cursor-pointer"
                                                                ></span>
                                                            </div>
                                                            <div
                                                                class="w-3 h-3 bg-secondaryCard rounded-sm flex-center-center hover:bg-black hover:text-white"
                                                                (click)="stopEdit(data.address)"
                                                            >
                                                                <span nz-icon nzType="close" class="!cursor-pointer"></span>
                                                            </div>
                                                        </div>
                                                    </ng-template>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </td>

                                <td>${{(data.networth || 0) | kmb2:2}}</td>

                                <td
                                    [ngClass]="{
                                        'text-success': data.realized_pnl_7d > 0,
                                        'text-error': data.realized_pnl_7d < 0
                                    }"
                                >
                                    {{formatTinyNumber(data.realized_pnl_7d || 0)}}
                                </td>
                                <td
                                    [ngClass]="{
                                        'text-success': data.realized_pnl_30d > 0,
                                        'text-error': data.realized_pnl_30d < 0
                                    }"
                                >
                                    {{formatTinyNumber(data.realized_pnl_30d || 0)}}
                                </td>
                                <td
                                    [ngClass]="{
                                        'text-success': data.win_rate > 0,
                                        'text-error': data.win_rate < 0
                                    }"
                                >
                                    {{data.win_rate ? (data.win_rate | percent:'1.0-2') : '--'}}
                                </td>
                            </tr>
                        </tbody>
                    </nz-table>

                    <ng-template #noResult>
                        <div class="flex-col flex-center-center gap-5 min-h-[200px]">
                            <ng-container *ngIf="watchList && !watchList.length">
                                <div class="text-center text-sm font-medium">Track wallets of your choice</div>

                                <button nz-button (click)="memeDashboardService.showAddWatchlistDialog()" class="w-24">
                                    <span nz-icon nzType="plus"></span>
                                    Add

                                    <div *ngIf="!isWatchListAdded" class="bonus-watchlist-points z-10">
                                        <img src="/assets/imgs/icon/sun-v2.png" class="w-[14px]" alt="" />
                                        <span>+100</span>
                                    </div>
                                </button>
                            </ng-container>

                            <ng-container *ngIf="!watchList">
                                <img src="/assets/imgs/no-data/no-data.png" alt="empty" class="w-[100px]" />
                                <div class="text-sm text-sub-text">No data</div>
                            </ng-container>
                        </div>
                    </ng-template>
                </div>
            </nz-tab>

            <nz-tab nzTitle="Recent TG Alerts ({{recentTgAlerts?.length || 0}})">
                <div class="max-md:hidden flex-start-center gap-x-3 w-full max-md:overflow-x-auto mb-5 pl-1 filter-buttons">
                    <button
                        *ngFor="let option of options"
                        nz-button
                        [ngClass]="{
                            'not-active': selectedAlertType !== option.value
                        }"
                        [disabled]="fetchingRecentTgAlerts"
                        (click)="toggleAlertType(option.value)"
                    >
                        {{option.label}}
                    </button>
                </div>

                <div class="flex-between-center md:hidden mb-4 overflow-x-auto gap-2">
                    <nz-select
                        nzSize="small"
                        [(ngModel)]="selectedAlertType"
                        class="md:hidden"
                        [nzOptions]="options"
                        (ngModelChange)="toggleAlertType($event)"
                        [nzDropdownMatchSelectWidth]="false"
                    ></nz-select>

                    <app-chain-select [(selectedChain)]="chain" (selectedChainChange)="chainChange()" class="chain-select"></app-chain-select>
                </div>

                <div class="flex justify-end items-center max-md:hidden !absolute right-0 top-2 z-10 gap-x-3">
                    <app-chain-select [(selectedChain)]="chain" (selectedChainChange)="chainChange()" class="chain-select"></app-chain-select>
                </div>

                <div class="space-y-3">
                    <app-recent-tg-alert-item *ngFor="let item of recentTgAlerts" [alertItem]="item" class="block"></app-recent-tg-alert-item>
                </div>

                <app-no-data *ngIf="!fetchingRecentTgAlerts && !recentTgAlerts?.length"></app-no-data>

                <nz-skeleton *ngIf="!isLastPage" appScrollObserver (scrolledIntoView)="fetchAlerts()" [nzActive]="true" class="mt-5"></nz-skeleton>
            </nz-tab>
        </nz-tabset>
    </div>
</section>
